import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useCart } from './CartContext';
import { useAuth } from './AuthContext';
import toast from 'react-hot-toast';
import './AddToCart.css';

const AddToCart = () => {
    const {
        cartItems,
        updateQuantity,
        removeItem,
        updateDuration,
        saving,
        getRemainingStock
    } = useCart();
    const { isAuthenticated, loading } = useAuth();
    const history = useHistory();

    const subtotal = cartItems
        .reduce((sum, item) => sum + parseFloat(item.price) * item.quantity, 0)
        .toFixed(2);

    const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

    const handleDecrease = (index) => {
        const item = cartItems[index];
        if (item.quantity > 1) {
            updateQuantity(index, item.quantity - 1);
        }
    };

    const handleIncrease = (index) => {
        const item = cartItems[index];
        const remaining = getRemainingStock(item.id, item.selected_duration, item.stock);

        if (item.quantity < item.stock && remaining > 0) {
            updateQuantity(index, item.quantity + 1);
        } else {
            toast.error(`Only ${item.stock} available for this variant`);
        }
    };

    const handleDurationChange = (index, newDuration) => {
        updateDuration(index, newDuration);
    };

    useEffect(() => {
        if (loading) return;
        if (!isAuthenticated) {
            history.push('/login');
        }
    }, [isAuthenticated, loading, history]);

    return (
        <div className="cart-page">
            <h1>Your Cart</h1>

            {saving && (
                <div className="saving-cart-text">⏳ Saving cart...</div>
            )}

            {cartItems.length === 0 ? (
                <p className="empty-cart">Your cart is empty.</p>
            ) : (
                <>
                    <div className="cart-items">
                        <div className="cart-devide-item-card">
                            <div className="cart-column product-col">Product</div>
                            <div className="cart-column price-col">Price</div>
                            <div className="cart-column variant-col">Variant</div>
                            <div className="cart-column quantity-col">Quantity</div>
                        </div>

                        {cartItems.map((item, index) => {
                            const remainingStock = getRemainingStock(item.id, item.selected_duration, item.stock);

                            return (
                                <div key={index} className="cart-item-card">
                                    <button className="remove-btn" onClick={() => removeItem(index)}>×</button>
                                    <div className="cart-image-wrapper">
                                        <img
                                            src={item.image_link || '/placeholder.jpg'}
                                            alt={item.name}
                                            className="cart-image"
                                        />
                                    </div>

                                    <div className="cart-item-details">
                                        <div className="product-title">{item.name}</div>
                                        <div className="cart-price">RM{parseFloat(item.price).toFixed(2)}</div>

                                        <div className="variant-select-wrapper">
                                            <select
                                                value={item.selected_duration}
                                                onChange={(e) => handleDurationChange(index, e.target.value)}
                                                className="variant-select"
                                                disabled={saving}
                                            >
                                                {Object.entries(item.product_data || {}).map(([duration, data]) => {
                                                    const remaining = getRemainingStock(item.id, duration, data.count);

                                                    return (
                                                        <option
                                                            key={duration}
                                                            value={duration}
                                                            disabled={remaining <= 0}
                                                        >
                                                            {duration}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>

                                        <div className="cart-item-bottom-row">
                                            <div className="quantity-controls">
                                                <button
                                                    onClick={() => handleDecrease(index)}
                                                    disabled={item.quantity <= 1 || saving}
                                                >-</button>
                                                <span>{item.quantity}</span>
                                                <button
                                                    onClick={() => handleIncrease(index)}
                                                    disabled={item.quantity >= item.stock || remainingStock <= 0 || saving}
                                                >+</button>
                                            </div>
                                            <div className="stock-info">
                                                In stock: {remainingStock >= 0 ? remainingStock : 0}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="cart-summary-section">
                        <div className="cart-info-card">
                            <h3>Total Items</h3>
                            <p>{totalItems} item(s)</p>
                        </div>
                        <div className="cart-info-card">
                            <h3>Subtotal</h3>
                            <p>RM{subtotal}</p>
                        </div>
                        <button
                            className="checkout-btn"
                            onClick={() => history.push('/checkout')}
                            disabled={cartItems.length === 0 || saving}
                        >
                            {saving ? 'Saving...' : 'Proceed to Checkout'}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default AddToCart;
